export default {
      id: "claim-1-usage",
      viewBox: "0 0 27 32",
      url: __webpack_public_path__ + "sprite.svg#claim-1",
      toString: function () {
        return this.url;
      }
    }